import ScrollReveal from './ScrollReveal';

interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  index,
  eyebrow,
  title,
  subtitle,
  align = 'center',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <ScrollReveal>
      <div className={`mb-14 md:mb-20 ${isCenter ? 'text-center' : 'text-left'}`}>
        <div className={`flex items-center gap-3 ${isCenter ? 'justify-center' : ''}`}>
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg border-2 border-gray-900 bg-pink-50 font-serif text-sm font-bold text-pink-500 shadow-[3px_3px_0_0_#ff9db8]">
            {index}
          </span>
          <span className="text-xs tracking-[0.25em] text-gray-500 font-medium uppercase">
            {eyebrow}
          </span>
        </div>
        <h2 className="mt-5 font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
          {title}
        </h2>
        {subtitle && (
          <p
            className={`mt-5 text-gray-500 text-base md:text-lg leading-relaxed max-w-2xl ${
              isCenter ? 'mx-auto' : ''
            }`}
          >
            {subtitle}
          </p>
        )}
      </div>
    </ScrollReveal>
  );
}